<template>
    <div class="footBox">
        <div class="foot">
            <div class="footLeft">
                <div class="footTitle">{{ footData.company }}</div>
                <div class="footText">地址: {{ footData.address }}</div>
                <!-- <div class="footText">ICP: {{ footData.icp }}</div> -->
                <div class="footText">统一社会信用代码: {{ footData.xinyongdaima }}</div>
                <div class="footText" style="cursor: pointer;" @click="recordTap">备案号: {{ footData.beian }}</div>
            </div>
            <div class="footRight">
                <div class="footContact">
                    <div class="contact">
                        <div class="codeTips">扫码体验</div>
                        <el-image v-if="footData.xcxcode" :src="footData.xcxcode" fit="cover" class="contactCode"></el-image>
                        <div class="codeTips">微信小程序</div>
                    </div>
                    <div class="contact">
                        <div class="codeTips">扫码关注</div>
                        <el-image v-if="footData.gzhcode" :src="footData.gzhcode" fit="cover" class="contactCode"></el-image>
                        <div class="codeTips">微信公众号</div>
                    </div>
                </div>
                <div class="footTel">联系电话: {{ footData.tel }}</div>
            </div>
        </div>
        <div class="copyright">Copyright©2019 {{ footData.company }} 版权所有</div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                footData: {},
            }
        },
        mounted(){
            this.getAppFoot()
        },
        methods: {
            // 网站尾数据
            getAppFoot(){
                this.request.get("index/index/bottom",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.footData = res.data
                })
            },
            // 跳转备案
            recordTap(){
                window.location.href = 'https://beian.miit.gov.cn/'
            }
        }
    }
</script>
<style lang="less" scoped>
    .footBox{
        width: 100vw;
        background: #141F33;
        color: #fff;
        .foot{
            width: 1176px;
            padding: 0 24px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .footLeft{
                padding-top: 9px;
                .footTitle{
                    font: 22px/22px "Microsoft YaHei";
                    padding: 36px 0
                }
                .footText{
                    font: 14px/26px "Microsoft YaHei";
                }

            }
            .footRight{
                padding: 14px 20px 0 0;
                .footContact{
                    width: 240px;
                    display: flex;
                    justify-content: space-between;
                    padding-left: 100px;
                    .contact{
                        width: 88px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .codeTips{
                            font: 14px/42px "Microsoft YaHei";
                            color: #fff;
                        }
                        .contactCode{
                            width: 88px;
                            height: 88px;
                            background: #fff;
                        }
                    }
                }
                .footTel{
                    font: 16px/16px "Microsoft YaHei";
                    text-align: right;
                    padding-top: 22px;
                }
            }
        }
        .copyright{
            width: 1150px;
            font: 14px/14px "Microsoft YaHei";
            padding: 34px 0;
            margin: 48px auto 0 auto;
            text-align: center;
            border-top: 1px solid #fff;
        }
    }
</style>